"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Wed Sep 26 2018
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * DataPairingStatsDTOConverter
 *
 * @author RV
 */


var DataPairingStatsDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(DataPairingStatsDTOConverter, _DataObjectConverter_);

  function DataPairingStatsDTOConverter() {
    _classCallCheck(this, DataPairingStatsDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(DataPairingStatsDTOConverter).apply(this, arguments));
  }

  return DataPairingStatsDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.DataPairingStatsDTOConverter = DataPairingStatsDTOConverter;